import {
    signalStore,
    withState,
    withComputed,
    withMethods,
    patchState,
} from '@ngrx/signals';
import { OrganizationSite } from 'api/models/organization-site';
import { SelfCheckinInformation } from 'api/models/self-checkin-information';
import {
    LoginResponse,
    OrganizationForServiceProvider,
    SelfServiceConfigCheckinWithTokensResponse,
} from 'api/models';

export interface SelfserviceState {
    organizationSite: OrganizationSite | undefined;
    tour: SelfCheckinInformation | undefined;
    me: LoginResponse | undefined;
    tokenUpdates: any[];
    selfServiceConfig: SelfServiceConfigCheckinWithTokensResponse | null;
    companyToEdit: OrganizationForServiceProvider | undefined;
}

const initialState: SelfserviceState = {
    organizationSite: undefined,
    tour: undefined,
    me: undefined,
    tokenUpdates: [],
    selfServiceConfig: null,
    companyToEdit: undefined,
};

// ---------- NgRx Signal Store ----------
export const SelfserviceStore = signalStore(
    { providedIn: 'root' },
    withState<SelfserviceState>({ ...initialState }),
    withComputed(() => ({
        // All state fields are exposed as signals by withState.
        // No additional derived computeds needed.
    })),
    withMethods(store => ({
        setSelfserviceOrganizationSite(site: OrganizationSite | undefined): void {
            patchState(store, { organizationSite: site });
        },
        setSelfserviceTour(tour: SelfCheckinInformation | undefined): void {
            patchState(store, { tour });
        },
        setSelfserviceMe(me: LoginResponse | undefined): void {
            patchState(store, { me });
        },
        setSelfserviceTokenUpdates(tokenUpdates: any[]): void {
            patchState(store, { tokenUpdates });
        },
        setSelfserviceSelfServiceConfig(
            selfServiceConfig: SelfServiceConfigCheckinWithTokensResponse | null
        ): void {
            patchState(store, { selfServiceConfig });
        },
        setSelfserviceCompanyToEdit(
            companyToEdit: OrganizationForServiceProvider | undefined
        ): void {
            patchState(store, { companyToEdit });
        },
        clearSelfserviceUserData(): void {
            patchState(store, { me: undefined, tour: undefined });
        },
    }))
);

